<template>
    <div class="d-flex align-items-center text-uppercase">
        <div class="mr-1">
            <span v-if="language === 'en' || language === 'us'">
                <flag iso="us"/>
            </span>
            <span v-if="language === 'es' || language === 'sp'">
                <flag iso="es"/>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        language: String,
    }
}
</script>
